import { PREDEFINED_PERIODS_OFFER_LOGIC } from '../store/types'

export class Environment{
    public static apiUrl = process.env.NODE_ENV === 'development' ?
      "https://localhost:9447/Api/" :
      process.env.REACT_APP_BACKEND_URL as string;

    public static representativePageUrl = process.env.NODE_ENV === 'development' ?
    "https://localhost:3001/" :
    process.env.REACT_APP_INFO_URL as string;    

    public static OPENA_FORM_PRD_URL = "app.opena";
    public static phoneNumberPrefix = "+48 ";
    public static grantType = "otp_credentials";
    public static clientId = "otp.web";
    public static clientSecret = "otp.web";
    public static scope = "openid"
    public static hintsTime = 5000;
    public static stepTime = 5000;
    public static marketingInfo = 7000;
    public static mobileMaxWidth = 700;
    public static tabletMinWidth = 601;

    //LENTOS CONFIG
    public static agentChanel = "OTP5"
    public static sendSmsLimit = 5; 
    public static sendSmsBlockingTimeInMs = 10000;
    public static minimumLoanAmount = 2000;  
    public static phoneNumber = "58 73 900 99";  
    public static isPhoneNumberAvaliable = true;  
    public static officeOpenTime = "8:00";  
    public static officeClosedTime = "17:00";  
    public static workTimeFrom = {hours: 9, minutes: 0};  
    public static workTimeTo = {hours: 16, minutes: 50};  
    public static defaultOfferSliderSteps =   {0: 50, 10000:100, 15000:500}
    public static defaultAffiliateCookieExpiresTimeInHours = 720
    public static desktopBreakpoint = 600 //todokrystian 1200
    // Szerokość ekranu od której przyjmujemy że urządzenie to desktop
    public static fieldErrorClassName = 'form-input-base-error'
    public static appConsentsErrorClassName = 'app-consents-main-error'
    public static fieldBaseClassName = 'form-input-base-container'
    public static CONTRACT_SIGN_BUTTON_ID = 'contract-signing-page-submit-button'
    public static defaultWorkFromHours = "09:00"; // Domyślna godzina rozpoczęcia pracy weryfikatora manualnego
    public static LEAD_OPENA_NULL_KEY = "OpenaNull" // Unikalny klucz, używany dla specjalnego rodzaju lead'a Openy
    public static DEFAULT_SNACKBAR_AUTO_HIDE_DURATION_IN_MS = 5000

    public static applicationStatuses: {[key: string]: string} = {
        NEW: 'NEW',
        AIS: 'AIS',
        PP:  'PP',
        AI:  'AI',
    }


    //[ZAŁOŻENIE BIZNESOWE] mechanizm z PREDEFINIOWANYMI OKRESAMI POŻYCZKI
    public static PREDEFINED_PERIODS_OFFER_LOGIC_INSTALMENT_MAP = {
      [PREDEFINED_PERIODS_OFFER_LOGIC.SHORT_PERIOD]: 12,
      [PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD]: 42,
    };

    public static maxShortLoanPeriodRequestedAmount = 10000;
}